import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import { BookingEvent } from '@bookings/interfaces/booking-event';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
const ConfirmationModal = () =>
  import('@shared/components/modals/confirmation-modal/confirmation-modal.vue');
const StdForm = () => import('../../auto-form/std-form/std-form.vue');
const EntityDeleteModalProvider = () =>
  import('@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue');

import { library } from '@fortawesome/fontawesome-svg-core';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BpcDrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
library.add(faPlus);

@Component({
  name: 'bpc-order-table-input',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-std-form': StdForm,
    'bpc-entity-table': EntityTable,
    'bpc-field-wrapper': FieldWrapper,
    'bpc-confirmation-modal': ConfirmationModal,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-drawer-modal': BpcDrawerModal,
  },
})
export default class OrderTableInput extends mixins(AbstractField, AbstractTable) {
  @Prop(Array) readonly value: any[];

  @Prop(String) readonly selectEntity: string;
  @Prop(String) readonly selectPluralEntity: string;

  @Prop({ type: String, default: 'drawer' }) readonly type: string;

  @Prop(Array) readonly filters: any[];
  @Prop(String) readonly fieldForStorage: string;

  @Prop(Boolean) readonly withDraft: boolean;

  //@Prop(String) readonly formConfigName: string;
  @Prop({ type: String, default: null }) readonly editFormConfigName: string;

  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;

  get model(): any[] {
    return this.value;
  }
  set model(val: any[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }
  @Watch('value')
  updateItemsProvider() {
    this.$refs.provider.items = this.value;
    if (this.value) {
      if (this.getMode() == 'storage') {
        this.$bpcStorage.set(this.selectPluralEntity, this.value);
      }
      this.updateRowsActions();
    }
  }

  public entity: any = null;
  public entityName = this.selectEntity;
  public pluralEntityName = this.selectPluralEntity;

  onChange($event) {
    this.$emit('change', $event);
  }

  // TODO: Determine if model has ID or not to consume api or create in localstorage.
  getMode(): string {
    const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
    if (filter['value']) {
      return 'api';
    } else {
      return 'storage';
    }
  }
  updateModel(): void {
    this.model = this.$refs.provider ? this.$refs.provider.items : null;
  }

  onFormSave() {
    const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
    if (filter['value']) {
      this.$refs.stdForm.formModel[filter['filterField']] = filter['value'];
    }
    this.$refs.stdForm.saveEntity();
  }

  onNew() {
    this.$bpcStorage.clear('order-items');
    this.entity = null;
    this.showForm = true;
    if (this.type === 'drawer') {
      // this.$bvModal.show('modal-resource-form');
      this.showDrawerSection = true;
    } else if (this.type === 'modal') {
      this.$bvModal.show(`${this.selectEntity}-entity-table-input-modal`);
    }
    this.disabledForm = false;
  }

  onEdit(e, disabled = false) {
    this.$bpcStorage.clear('order-items');
    this.entity = e.item;
    this.showForm = true;
    if (this.type === 'drawer') {
      this.showDrawerSection = true;
    } else if (this.type === 'modal') {
      this.$bvModal.show(`${this.selectEntity}-entity-table-input-modal`);
    }
    setTimeout(() => {
      this.disabledForm = disabled;
    });
  }

  onFormClose() {
    this.showForm = false;
    if (this.type === 'drawer') {
      this.showDrawerSection = false;
    } else if (this.type === 'modal') {
      this.$bvModal.hide(`${this.selectEntity}-entity-table-input-modal`);
    }
    this.showDrawerSection = false;
    this.$refs.provider.getEntities();
  }

  get showedFields() {
    const showedFields = [];
    for (const field of this.$refs.provider.fields) {
      if (!field['conditionalShow']) {
        showedFields.push(field);
      } else {
        const keys = field['conditionalShow']['fieldPath'].split('.');
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let conditionalValue = this;
        for (const key of keys) {
          if (conditionalValue[key] != 'undefined') {
            conditionalValue = conditionalValue[key];
          } else {
            break;
          }
        }
        if (conditionalValue === field['conditionalShow']['value']) {
          showedFields.push(field);
        }
      }
    }
    return showedFields;
  }

  calculateTotalPrice() {
    // Same logic than in calculateTotalPrice() from order-table.ts
    const orderItems = this.$refs.stdForm.formModel.orderItems;
    let totalPrice: number = 0;
    let totalTax: number = 0;
    let totalPriceExcludingTax: number = 0;
    orderItems.forEach(item => {
      const discount = item.discount ? item.discount : 0;
      const discount_type = item.discount_type_value ? item.discount_type_value : 'percentage';
      let itemTotalPrice = 0;
      if (discount_type === 'percentage') {
        itemTotalPrice = item.price * item.quantity * (1 - discount / 100);
      } else {
        itemTotalPrice = item.price * item.quantity - discount;
      }
      totalPrice += itemTotalPrice;
      totalTax += itemTotalPrice - itemTotalPrice / (1 + item.tax_rate / 100);
      totalPriceExcludingTax = totalPrice - totalTax;
    });
    this.$set(
      this.$refs.stdForm.formModel,
      'total_price',
      Number.isNaN(totalPrice) ? null : totalPrice.toFixed(2),
    );
    this.$set(
      this.$refs.stdForm.formModel,
      'total_tax',
      Number.isNaN(totalTax) ? null : totalTax.toFixed(2),
    );
    this.$set(
      this.$refs.stdForm.formModel,
      'total_excluding_tax_price',
      Number.isNaN(totalPriceExcludingTax) ? null : totalPriceExcludingTax.toFixed(2),
    );
    this.calculateBalance();
  }

  calculateBalance() {
    const totalPrice = this.$refs.stdForm.formModel.total_price;
    const paid = this.$refs.stdForm.formModel.paid;
    this.$set(
      this.$refs.stdForm.formModel,
      'balance',
      (totalPrice - paid).toFixed(2).replace('.', ','),
    );
  }

  /* Lifecycle hooks */

  // created() {}
  mounted() {
    this.$root.$on('calculateTotalPriceFromOrderTableInput', event => {
      this.calculateTotalPrice();
    });
    this.$root.$on('calculateBalance', event => {
      this.calculateBalance();
    });
  }

  // destroyed() {}

  // updated() {}
  destroyed() {
    this.$root.$off('calculateTotalPriceFromOrderTableInput');
    this.$root.$off('calculateBalance');
  }
}
